<template>
	<div class="number-stepper">
		<b-input-group class="stepper-input">
			<b-button class="-prev" @click="innerStepDown">&#9664;</b-button>
			<b-form-input class="-value"
			              :class="inputClasses"
			              :value="leftPaddedValue"
			              @input="handleInputValue"></b-form-input>
			<b-button class="-next" @click="innerStepUp">&#9654;</b-button>
		</b-input-group>
	</div>
</template>

<script>
export default {
	name: 'ErcoNumberStepperAtom',

	data() {
		return {
			currentValue: null,
		};
	},

	props: {
		value: {
			type: Number,
		},

		min: {
			type: Number,
			default: null,
		},

		max: {
			type: Number,
			default: null,
		},

		step: {
			type: Number,
			default: 1,
		},

		leftPadLength: {
			type: Number,
			default: null,
		},

		stepDown: {
			type: Function,
			default: null,
		},

		stepUp: {
			type: Function,
			default: null,
		},

		validator: {
			type: Function,
			default: value => !!value.match(/\d*/),
		},
	},

	computed: {
		leftPaddedValue() {
			let retVal = this.computedValue.toString();

			if (this.leftPadLength !== null && retVal !== '') {
				retVal = retVal.padStart(this.leftPadLength, '0');
				retVal = retVal.substr(retVal.length - this.leftPadLength);
			}

			return retVal;
		},

		computedValue: {
			set(value) {
				this.currentValue = value;
			},

			get() {
				return (this.currentValue !== null) ? this.currentValue : this.value;
			},
		},

		inputClasses() {
			const inputClasses = {};

			if (!this.validator(this.computedValue.toString())) {
				inputClasses['-invalid'] = true;
			}

			return inputClasses;
		},
	},

	methods: {
		handleInputValue(newValue) {
			this.computedValue = this.keepInBound(newValue);
			this.handleValueChange();
		},

		handleValueChange() {
			if (this.validator(this.computedValue.toString())) {
				this.$emit('change', parseInt(this.computedValue, 10));
			}
		},

		innerStepDown() {
			const value = (this.stepDown && this.stepDown(this.computedValue)) ||
			                     (parseInt(this.computedValue, 10) - this.step);

			this.computedValue = this.keepInBound(value);
			this.handleValueChange();
		},

		innerStepUp() {
			const value = (this.stepUp && this.stepUp(this.computedValue)) ||
			              (parseInt(this.computedValue, 10) + this.step);

			this.computedValue = this.keepInBound(value);
			this.handleValueChange();
		},

		keepInBound(val) {
			const min = this.min;
			const max = this.max;

			let retVal = parseInt(val, 10) || 0;

			if (max !== null && retVal > max) {
				retVal = (min !== null) ? min : max;
			}

			if (min !== null && retVal < min) {
				retVal = (max !== null) ? max : min;
			}

			return retVal;
		},
	},
};
</script>

<style lang="scss">
	.number-stepper {
		display: inline-block;

		.stepper-input {
			& > .-prev {
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
			}
			& > .-value {
				border-left: 0;
				border-right: 0;
				text-align: center;

				&.-invalid {
					border-color: rgb(217, 83, 79);
				}
			}
			& > .-next {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// ErcoNumberStepper.vue?8fd2437e